import {
  CartDetails,
  getUpdatedPhysicalProducts,
} from "../../lib/cart/CartDetails";
import { useContext, useState } from "react";

import AddToCartButton from "./AddToCartButton";
import { CartContext } from "../../contexts/CartContext";
import FoundryLink from "../../components/FoundryLink";
import FoundryPhysicalProduct from "../../lib/foundry_client/models/FoundryPhysicalProduct";
import { PhysicalProductsContext } from "../../contexts/PhysicalProductsContext";
import ResponsiveImage from "../ResponsiveImage";
import Routes from "../../routes";
import { formatMoney } from "../../util/strings";
import { motion } from "framer-motion";
import { savePhysicalProducts } from "../../lib/cart/CartStorage";
import { toast } from "react-toastify";

interface ProductCardProps {
  product: FoundryPhysicalProduct;
  hidePricing?: boolean;
  hideButton?: boolean;
}

export default function ProductCard({
  product,
  hidePricing,
  hideButton,
}: ProductCardProps) {
  const { cartDetails, propagateCartDetails } = useContext(CartContext);
  const { physicalProducts } = useContext(PhysicalProductsContext);
  const [imageIdx, setImageIdx] = useState(0);

  // TODO: temporary
  const profileImage =
    product.profileImages.length > 0
      ? product.profileImages[0]
      : product.images[0];

  const physicalProductDetails = physicalProducts.find(
    (p) => p.id === product.id
  );

  let isSoldOut = false;
  if (physicalProductDetails) {
    isSoldOut =
      physicalProductDetails.maxQuantity <=
      physicalProductDetails.orderedQuantity;
  }

  return (
    <motion.div
      className="flex flex-col gap-4 z-[110]"
      style={{ translateY: 30, opacity: 0 }}
      initial={{ translateY: 30, opacity: 0 }}
      whileInView={{ translateY: 0, opacity: 1 }}
      viewport={{ once: true, amount: "some" }}
      transition={{
        duration: 0.3,
      }}
    >
      <FoundryLink
        href={Routes.shop.product(product.slug)}
        className="relative"
        onMouseEnter={() => {
          if (product.profileImages.length > 1) {
            setImageIdx(1);
          }
        }}
        onMouseOut={() => setImageIdx(0)}
      >
        {product.profileImages.length > 1 && (
          <ResponsiveImage
            src={product.profileImages[1].fileUrl}
            alt={product.profileImages[1].description}
            sizes="(max-width: 768px) 40vw, (max-width: 1440px) 25vw, 350px"
            styles={{
              objectFit: "cover !important",
              aspectRatio: "1",
            }}
            containerClassNames={`${imageIdx > 0 ? "opacity-100" : "opacity-0"
              } absolute top-0 left-0 transition-opacity ease-in duration-300 z-110`}
          ></ResponsiveImage>
        )}
        <ResponsiveImage
          src={profileImage?.fileUrl}
          alt={profileImage?.description}
          sizes="(max-width: 768px) 40vw, (max-width: 1440px) 25vw, 350px"
          styles={{ objectFit: "cover !important", aspectRatio: "1" }}
          containerClassNames={
            product.profileImages.length > 1
              ? "transition-opacity ease-in duration-300 opacity-100 lg:hover:opacity-0"
              : ""
          }
        ></ResponsiveImage>
      </FoundryLink>
      <div
        className={`gap-4 grid grid-cols-1 ${!isSoldOut && "xl:grid-cols-2"}`}
      >
        <div
          className={`${hideButton || isSoldOut
            ? "col-span-2"
            : "col-span-1 xl:text-start xl:items-start xl:justify-between gap-1 xl:gap-0"
            } flex flex-col h-full items-center text-center`}
        >
          <FoundryLink href={Routes.shop.product(product.slug)}>
            <span className="t7 color-blue-hover">{product.name}</span>
          </FoundryLink>
          {!hidePricing && (
            <>
              <span>{formatMoney("USD", product.priceCents)}</span>
              {isSoldOut && (
                <span className="mt-3 px-3 py-2 bg-pink rounded text-xs">
                  Sold out
                </span>
              )}
            </>
          )}
        </div>
        {!hidePricing && !hideButton && !isSoldOut && (
          <AddToCartButton
            extraClasses="hidden lg:block"
            onClick={() => {
              const newState = getUpdatedPhysicalProducts(
                cartDetails?.physicalProducts,
                product.id,
                { quantityChange: 1 }
              );

              const newProductState = newState.find(
                (p) => p.contentfulId === product.id
              );

              if (newProductState) {
                const error = CartDetails.getPhysicalProductError(
                  physicalProducts,
                  newProductState
                );

                if (error) {
                  toast.error(error.message);
                  return false;
                }
              }

              console.log("saving");
              console.log(newState);

              savePhysicalProducts(newState);
              propagateCartDetails();
              return true;
            }}
          />
        )}
      </div>
    </motion.div>
  );
}
